// https://mathiasbynens.be/notes/globalthis
"object"!=typeof globalThis&&(Object.defineProperty(Object.prototype,"__magic__",{get:function(){return this},configurable:!0}),__magic__.globalThis=__magic__,delete Object.prototype.__magic__);

if (typeof globalThis.ticketack_is_filled_localized !== 'function') {
    globalThis.ticketack_is_filled_localized = function (value) {
        if (value == null) {
            return false;
        }
        return String(value).trim().length > 0;
    };
}

if (typeof globalThis.localized_or_default !== 'function') {
    // Same chain as js-lib StringsHelper.getLocalizedValue (POS has no Ticketack instance).
    globalThis.localized_or_default = function (obj) {
        if (obj == null) {
            return null;
        }
        if (typeof obj === 'string') {
            return globalThis.ticketack_is_filled_localized(obj) ? obj : null;
        }
        if (typeof obj !== 'object' || Array.isArray(obj)) {
            return null;
        }
        var PosConfig = globalThis.PosConfig || {};
        var filled = globalThis.ticketack_is_filled_localized;
        if (PosConfig.lang && filled(obj[PosConfig.lang])) {
            return obj[PosConfig.lang];
        }
        if (filled(obj.original)) {
            return obj.original;
        }
        if (PosConfig.default_lang && filled(obj[PosConfig.default_lang])) {
            return obj[PosConfig.default_lang];
        }
        for (var key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key) && filled(obj[key])) {
                return obj[key];
            }
        }
        return null;
    };
}

if (typeof globalThis.article_variant_name_is_hidden !== 'function') {
    globalThis.article_variant_name_is_hidden = function (articleName, variantName) {
        var variant = String(variantName == null ? '' : variantName).trim();
        if (!variant || variant === '-') {
            return true;
        }
        var article = String(articleName == null ? '' : articleName).trim();
        return !!article && article.toLowerCase() === variant.toLowerCase();
    };
}

if (typeof globalThis.localized_title_or_original !== 'function') {
    globalThis.localized_title_or_original = function (title) {
        if (!title) {
            return null;
        }
        var PosConfig = globalThis.PosConfig || {};
        var filled = globalThis.ticketack_is_filled_localized;
        if (PosConfig.lang && filled(title[PosConfig.lang])) {
            return title[PosConfig.lang];
        }
        if (PosConfig.default_lang && PosConfig.default_lang !== PosConfig.lang && filled(title[PosConfig.default_lang])) {
            return title[PosConfig.default_lang];
        }
        return filled(title.original) ? title.original : null;
    };
}

if (typeof globalThis.ticketack_pricing_can_be_sold_at_salepoint !== 'function') {
    globalThis.ticketack_pricing_can_be_sold_at_salepoint = function (pricing, salepoint_id) {
        if (!pricing || !pricing.rules || !Object.prototype.hasOwnProperty.call(pricing.rules, 'only_for_salepoints')) {
            return true;
        }
        var allowed = pricing.rules.only_for_salepoints;
        if (!allowed || !allowed.length || salepoint_id == null || salepoint_id === '') {
            return true;
        }
        return allowed.indexOf(salepoint_id) !== -1;
    };
}

if (typeof globalThis.ticketack_pricing_is_available_at !== 'function') {
    globalThis.ticketack_pricing_is_available_at = function (pricing, at_ms) {
        if (!pricing || !pricing.rules) {
            return true;
        }

        var at = at_ms;
        if (at instanceof Date) {
            at = at.getTime();
        }
        if (typeof at !== 'number' || isNaN(at)) {
            at = Date.now();
        }

        if (Object.prototype.hasOwnProperty.call(pricing.rules, 'not_before')) {
            var nb = Date.parse(pricing.rules.not_before);
            if (!isNaN(nb) && at < nb) {
                return false;
            }
        }

        if (Object.prototype.hasOwnProperty.call(pricing.rules, 'not_after')) {
            var na = Date.parse(pricing.rules.not_after);
            if (!isNaN(na) && at > na) {
                return false;
            }
        }

        return true;
    };
}

/**
 * Seller roles from rules.only_for_roles only (Engine may dual-emit
 * top-level sellers for legacy WP; new clients must ignore it).
 * Returns null when the key is absent (unrestricted). Empty [] = nobody.
 */
if (typeof globalThis.ticketack_pricing_roles !== 'function') {
    globalThis.ticketack_pricing_roles = function (pricing) {
        if (!pricing || !pricing.rules || !Object.prototype.hasOwnProperty.call(pricing.rules, 'only_for_roles')) {
            return null;
        }
        return Array.isArray(pricing.rules.only_for_roles) ? pricing.rules.only_for_roles : [];
    };
}

/**
 * Override-if-set sellable-by-roles (pricing then tickettype).
 * Missing on both = unrestricted. Empty [] = nobody.
 */
if (typeof globalThis.ticketack_merged_sellable_by !== 'function') {
    globalThis.ticketack_merged_sellable_by = function (tickettype, pricing, roles) {
        var allowed = null;
        if (pricing && pricing.rules && Object.prototype.hasOwnProperty.call(pricing.rules, 'only_for_roles')) {
            allowed = Array.isArray(pricing.rules.only_for_roles) ? pricing.rules.only_for_roles : [];
        } else if (tickettype && tickettype.rules && Object.prototype.hasOwnProperty.call(tickettype.rules, 'only_for_roles')) {
            allowed = Array.isArray(tickettype.rules.only_for_roles) ? tickettype.rules.only_for_roles : [];
        }
        if (allowed === null) {
            return true;
        }
        if (!Array.isArray(roles)) {
            return false;
        }
        return allowed.filter(function (role) { return roles.includes(role); }).length > 0;
    };
}

/**
 * Stock gate for annotated pricings (PricingStockService sets
 * `_stock_max_quantity` / `_sold_count` from tickettype rules.stocks).
 * Without annotation, treat as unlimited (server enforces on sale).
 */
if (typeof globalThis.ticketack_pricing_has_stock !== 'function') {
    globalThis.ticketack_pricing_has_stock = function (pricing, tickettype, pricing_key) {
        if (pricing && Object.prototype.hasOwnProperty.call(pricing, '_in_stock')) {
            return !!pricing._in_stock;
        }

        if (tickettype && pricing_key != null && pricing_key !== '' &&
            typeof globalThis.ticketack_pricing_stocks_in_stock === 'function') {
            return globalThis.ticketack_pricing_stocks_in_stock(pricing, tickettype, pricing_key);
        }

        if (!pricing || !Object.prototype.hasOwnProperty.call(pricing, '_stock_max_quantity')) {
            return true;
        }

        var max_quantity = Number(pricing._stock_max_quantity);
        if (!Number.isFinite(max_quantity) || max_quantity < 1) {
            return true;
        }

        var sold_count = Number(pricing._sold_count || 0);
        if (!Number.isFinite(sold_count) || sold_count < 0) {
            sold_count = 0;
        }

        return sold_count < max_quantity;
    };
}

/**
 * Resolve seat categories from rules.only_for_categories only.
 * absent → null (all); [] → none; non-empty → membership.
 */
if (typeof globalThis.ticketack_pricing_categories !== 'function') {
    globalThis.ticketack_pricing_categories = function (pricing) {
        if (!pricing || !pricing.rules) {
            return null;
        }
        if (!Object.prototype.hasOwnProperty.call(pricing.rules, 'only_for_categories')) {
            return null;
        }
        return Array.isArray(pricing.rules.only_for_categories)
            ? pricing.rules.only_for_categories
            : [];
    };
}

if (typeof globalThis.ticketack_pricing_allows_category !== 'function') {
    globalThis.ticketack_pricing_allows_category = function (pricing, seat_category) {
        if (!pricing || seat_category == null || seat_category === '') {
            return false;
        }
        var cats = globalThis.ticketack_pricing_categories(pricing);
        if (cats === null) {
            return true;
        }
        if (!cats.length) {
            return false;
        }
        return cats.indexOf(seat_category) !== -1;
    };
}

if (typeof globalThis.ticketack_pricing_seatless_pledge_category !== 'function') {
    globalThis.ticketack_pricing_seatless_pledge_category = function (pricing) {
        var cats = globalThis.ticketack_pricing_categories(pricing);
        if (cats === null) {
            return null;
        }
        if (cats.length === 1) {
            return cats[0];
        }
        return null;
    };
}

if (typeof globalThis.ticketack_pricing_seatless_pledge_candidates !== 'function') {
    globalThis.ticketack_pricing_seatless_pledge_candidates = function (pricing) {
        var cats = globalThis.ticketack_pricing_categories(pricing);
        if (cats === null) {
            return [null];
        }
        return cats;
    };
}

if (typeof globalThis.ticketack_otp_availability_pledge_categories !== 'function') {
    globalThis.ticketack_otp_availability_pledge_categories = function (pricings) {
        var cats = {};
        var each = (typeof _ !== 'undefined' && _.each) ? _.each : function (obj, fn) {
            Object.keys(obj || {}).forEach(function (k) { fn(obj[k], k); });
        };
        each(pricings || {}, function (pricing) {
            if (!pricing) {
                return;
            }
            var listed = globalThis.ticketack_pricing_categories(pricing);
            if (listed !== null && listed.length === 0) {
                return;
            }
            var single = globalThis.ticketack_pricing_seatless_pledge_category(pricing);
            if (single) {
                cats[single] = true;
                return;
            }
            if (listed) {
                listed.forEach(function (c) {
                    if (c) {
                        cats[c] = true;
                    }
                });
            }
        });
        return Object.keys(cats);
    };
}

/**
 * Best-effort client stock check against tickettype.rules.stocks.
 * Uses pricing._sold_count (pricing-scoped) vs override max when present;
 * pool-only caps without pool sold counts stay unlimited client-side.
 */
if (typeof globalThis.ticketack_pricing_stocks_in_stock !== 'function') {
    globalThis.ticketack_pricing_stocks_in_stock = function (pricing, tickettype, pricing_key) {
        if (!tickettype || !tickettype.rules || !tickettype.rules.stocks || pricing_key == null || pricing_key === '') {
            return true;
        }
        var stocks = tickettype.rules.stocks;
        var overrides = stocks.overrides || {};
        var override_node = overrides[pricing_key];
        var max_quantity = null;
        if (override_node) {
            max_quantity = Number(override_node.max_quantity);
            if (!Number.isFinite(max_quantity) || max_quantity < 1) {
                max_quantity = null;
            }
        }
        if (max_quantity === null) {
            return true;
        }
        var sold_count = Number((pricing && pricing._sold_count) || 0);
        if (!Number.isFinite(sold_count) || sold_count < 0) {
            sold_count = 0;
        }
        return sold_count < max_quantity;
    };
}

/**
 * True when a pricing's own category contingent still has a free place.
 * No category buckets (or no bucket context) → still available.
 * options: { buckets, roles, sync_assign, now }
 */
if (typeof globalThis.ticketack_pricing_has_category_capacity !== 'function') {
    globalThis.ticketack_pricing_has_category_capacity = function (pricing, options) {
        options = options || {};
        var buckets = options.buckets || [];
        var has_category_buckets = false;
        var i;
        for (i = 0; i < buckets.length; i++) {
            var rules = buckets[i] && buckets[i].rules;
            if (rules && Object.prototype.hasOwnProperty.call(rules, 'only_for_categories')) {
                has_category_buckets = true;
                break;
            }
        }
        if (!has_category_buckets) {
            return true;
        }
        var candidates = (typeof globalThis.ticketack_pricing_seatless_pledge_candidates === 'function')
            ? globalThis.ticketack_pricing_seatless_pledge_candidates(pricing)
            : [];
        if (!candidates.length) {
            return false;
        }
        if (typeof options.sync_assign !== 'function') {
            return true;
        }
        var roles = options.roles || [];
        var now = options.now || Date.now();
        var c;
        for (c = 0; c < candidates.length; c++) {
            var cat = candidates[c];
            if (cat && !globalThis.ticketack_pricing_allows_category(pricing, cat)) {
                continue;
            }
            if (options.sync_assign(buckets, 'one-time-pass', now, roles, cat)) {
                return true;
            }
        }
        return false;
    };
}

/**
 * hides_pricings_while_available applies only while this pricing still has
 * contingent capacity. A category-exhausted tier stays listed and must not
 * hide the next tier. cannot_book_reason is that exhausted mark.
 */
if (typeof globalThis.ticketack_pricing_hides_others_while_available !== 'function') {
    globalThis.ticketack_pricing_hides_others_while_available = function (pricing, options) {
        if (!pricing || !pricing.rules) {
            return false;
        }
        var targets = pricing.rules.hides_pricings_while_available;
        if (!Array.isArray(targets) || !targets.length) {
            return false;
        }
        if (pricing.cannot_book_reason) {
            return false;
        }
        options = options || {};
        if (typeof options.still_has_capacity === 'function') {
            return !!options.still_has_capacity(pricing);
        }
        if (options.buckets && typeof options.sync_assign === 'function') {
            return !!globalThis.ticketack_pricing_has_category_capacity(pricing, options);
        }
        return true;
    };
}

/**
 * Mark OTP pricings whose category contingent is full.
 * options: { buckets, bookings, roles, sync_assign, reason, now }
 */
if (typeof globalThis.ticketack_enrich_pricings_category_bookability !== 'function') {
    globalThis.ticketack_enrich_pricings_category_bookability = function (pricings, options) {
        options = options || {};
        if (!pricings || typeof pricings !== 'object') {
            return pricings;
        }
        var reason = options.reason
            || (typeof PosConfig !== 'undefined' && PosConfig.i18n && PosConfig.i18n.no_seats_for_category)
            || 'Plus de places disponibles pour cette catégorie';
        var bookings = options.bookings || [];
        Object.keys(pricings).forEach(function (key) {
            var pricing = pricings[key];
            if (!pricing) {
                return;
            }
            delete pricing.cannot_book_reason;
            var categories_to_check = [];
            bookings.forEach(function (b) {
                if (b && b.seat_category && categories_to_check.indexOf(b.seat_category) === -1) {
                    categories_to_check.push(b.seat_category);
                }
            });
            if (!categories_to_check.length) {
                categories_to_check = (typeof globalThis.ticketack_pricing_seatless_pledge_candidates === 'function')
                    ? globalThis.ticketack_pricing_seatless_pledge_candidates(pricing)
                    : [];
            }
            if (!categories_to_check.length) {
                pricing.cannot_book_reason = reason;
                return;
            }
            var any = categories_to_check.some(function (cat) {
                if (cat && !globalThis.ticketack_pricing_allows_category(pricing, cat)) {
                    return false;
                }
                if (cat && bookings.some(function (b) {
                    return b && b.seat_category === cat;
                })) {
                    return true;
                }
                if (!options.buckets || typeof options.sync_assign !== 'function') {
                    return true;
                }
                return !!options.sync_assign(
                    options.buckets, 'one-time-pass', options.now || Date.now(), options.roles || [], cat
                );
            });
            if (!any) {
                pricing.cannot_book_reason = reason;
            }
        });
        return pricings;
    };
}

if (typeof globalThis.ticketack_apply_hides_pricings_while_available !== 'function') {
    globalThis.ticketack_apply_hides_pricings_while_available = function (pricings_map, options) {
        if (!pricings_map || typeof pricings_map !== 'object') {
            return pricings_map;
        }

        var hidden = {};
        Object.keys(pricings_map).forEach(function (key) {
            var pricing = pricings_map[key];
            if (!globalThis.ticketack_pricing_hides_others_while_available(pricing, options)) {
                return;
            }
            var targets = pricing.rules.hides_pricings_while_available;
            targets.forEach(function (target) {
                if (typeof target === 'string' && target !== '') {
                    hidden[target] = true;
                }
            });
        });

        Object.keys(hidden).forEach(function (target_key) {
            delete pricings_map[target_key];
        });

        return pricings_map;
    };
}

/**
 * Keep in sync with AppRouter::img_proxy_url and other Ticketack weserv helpers
 * (stable query order for CDN cache hits; &we; &ll when longest side <= 64;
 * retina via extra w/h / srcset, not &dpr=).
 */
function img_proxy_url(url, max_width, max_height) {
    if (PosConfig.proxy_img_host == '') {
        return url;
    }

    var w = (max_width && max_width !== '-') ? max_width : null;
    var h = (max_height && max_height !== '-') ? max_height : null;
    var parts = ['url=' + encodeURIComponent(url)];
    if (w) {
        parts.push('w=' + encodeURIComponent(w));
    }
    if (h) {
        parts.push('h=' + encodeURIComponent(h));
    }
    parts.push('fit=outside', 'we', 'output=webp');
    var longest = Math.max(parseInt(w, 10) || 0, parseInt(h, 10) || 0);
    if (longest > 0 && longest <= 64) {
        parts.push('ll');
    } else {
        parts.push('q=80');
    }
    return '//' + PosConfig.proxy_img_host + '?' + parts.join('&');
}

function img_proxy_srcset_widths(max_width) {
    var width = parseInt(max_width, 10) || 0;
    if (width <= 0) {
        return [];
    }
    var widths = [];
    var half = Math.round(width / 2);
    if (half >= 200 && half < width) {
        widths.push(half);
    }
    widths.push(width, width * 2);
    return widths.filter(function (value, index, self) {
        return self.indexOf(value) === index;
    });
}

function img_proxy_scale_height(max_height, src_width, dst_width) {
    if (max_height == null || max_height === '' || max_height === '-') {
        return max_height === '-' ? '-' : max_height;
    }
    var src = parseInt(src_width, 10) || 0;
    var dst = parseInt(dst_width, 10) || 0;
    var height = parseInt(max_height, 10) || 0;
    if (src <= 0 || dst <= 0 || height <= 0) {
        return max_height;
    }
    return Math.round(height * dst / src);
}

function img_proxy_srcset(url, max_width, max_height) {
    var src_width = parseInt(max_width, 10) || 0;
    return img_proxy_srcset_widths(max_width).map(function (width) {
        return img_proxy_url(url, width, img_proxy_scale_height(max_height, src_width, width)) + ' ' + width + 'w';
    }).join(', ');
}

function img_proxy_sizes(max_width) {
    var width = parseInt(max_width, 10) || 0;
    if (width <= 0) {
        return '100vw';
    }
    return '(max-width: ' + width + 'px) 100vw, ' + width + 'px';
}

function img_proxy_background_image(url, max_width, max_height) {
    var url_1x = img_proxy_url(url, max_width, max_height);
    var width = parseInt(max_width, 10) || 0;
    if (width <= 0) {
        return "url('" + url_1x + "')";
    }
    var url_2x = img_proxy_url(url, width * 2, img_proxy_scale_height(max_height, width, width * 2));
    return "image-set(url('" + url_1x + "') 1x, url('" + url_2x + "') 2x)";
}

app.filter('filterHTML', function() {
    return function(text) {
        return text
            ? String(text)
                .replace(/<[^>]+>/gm, '')
                .replace(/&nbsp;/gi, ' ')
                .replace(/&#160;/gi, ' ')
                .replace(/&#x0*a0;/gi, ' ')
                .replace(/\u00a0/g, ' ')
                .replace(/\s+/g, ' ')
                .trim()
            : '';
    };
});

/**
 * Compact Swiss money without currency code.
 * Whole francs use an en-dash (U+2013): 200.–
 * Otherwise two decimals: 12.50
 * Thousands use apostrophe: 1'200.–
 */
app.filter('moneyShort', function() {
    var EN_DASH = '\u2013';
    return function(amount) {
        var value = Number(amount);
        if (!isFinite(value)) {
            return '';
        }
        var negative = value < 0;
        var abs = Math.abs(value);
        var units = Math.floor(abs + 1e-9);
        var cents = Math.round((abs - units) * 100);
        if (cents === 100) {
            units += 1;
            cents = 0;
        }
        var unitsStr = String(units).replace(/\B(?=(\d{3})+(?!\d))/g, "'");
        var body = cents === 0
            ? (unitsStr + '.' + EN_DASH)
            : (unitsStr + '.' + (cents < 10 ? '0' : '') + cents);
        return negative ? ('-' + body) : body;
    };
});

app.filter('trustAsHtml', ['$sce', function($sce) {
    return function(text) {
        return $sce.trustAsHtml(text ? String(text) : '');
    };
}]);

app.filter('warningLevel', function() {
    return function(percentage) {
    if (percentage == 0)
        return 'danger';
    else if (percentage <= globalThis.PosConfig.capacity_warn_level)
        return 'warning';
    else
        return 'success';
    };
});

app.filter('orderObjectBy', function(){
    return function(input, attribute) {
        if (!angular.isObject(input)) return input;

        var array = [];
        for(var objectKey in input) {
array.push(input[objectKey]);
        }

        array.sort(function(a, b){
a = parseInt(a[attribute]);
b = parseInt(b[attribute]);
return a - b;
        });
        return array;
    }
});

app.filter('bookingScreeningInTheFuture', function() {
    return function(bookings) {
        var now = Date.now();
        return bookings.filter(function (booking) {
return (booking.screening && Date.parse(booking.screening.stop_at) > now);
        });
    };
});

app.filter('badDateToISO', function() {
    return function(badTime) {
        if(!badTime) return null;
        /* Stored dates are not UTC, so no ending Z in date format */
        var goodTime = badTime.replace(/(.+) (.+)/, "$1T$2");
        return goodTime;
    };
});

app.filter('middleTruncate', function() {
    return function(str, max_length, separator) {
        if (str.length <= max_length) return str;

        separator = separator || '...';

        var chars_length = max_length - separator.length,
front_length = Math.ceil(chars_length/2),
back_length  = Math.floor(chars_length/2);

        return str.substr(0, front_length) +
   separator +
   str.substr(str.length - back_length);
    };
});

function getIntersect(arr1, arr2) {
    var r = [], o = {}, l = arr2.length, i, v;
    for (i = 0; i < l; i++) {
        o[arr2[i]] = true;
    }
    l = arr1.length;
    for (i = 0; i < l; i++) {
        v = arr1[i];
        if (v in o) {
r.push(v);
        }
    }
    return r;
}

/**
 * https://github.com/moment/moment/issues/3375
 *
 * Map Ticketack lang codes to Swiss moment locales (fr → fr-ch, de → de-ch)
 * and fix fr-ch day-of-month ordinals: Do → 1er / 27 (not 27e).
 * Related PR (fr-ca only): https://github.com/moment/moment/pull/6449
 */
if (typeof globalThis.ticketack_moment_locale !== 'function') {
    globalThis.ticketack_moment_locale = function (lang) {
        var base = String(lang || 'fr').toLowerCase().split(/[-_]/)[0];
        if (base === 'fr')
            return 'fr-ch';
        if (base === 'de')
            return 'de-ch';
        if (base === 'en')
            return 'en-gb';
        if (base === 'it')
            return 'it';
        return 'fr-ch';
    };
}

if (typeof globalThis.ticketack_patch_moment_fr_ch_ordinal !== 'function') {
    globalThis.ticketack_patch_moment_fr_ch_ordinal = function (momentLib) {
        var m = momentLib || globalThis.moment;
        if (!m || typeof m.updateLocale !== 'function')
            return;
        if (m.__ticketack_fr_ch_ordinal_patched)
            return;

        m.updateLocale('fr-ch', {
            ordinal: function (number, period) {
                switch (period) {
                    case 'D':
                        return number + (number === 1 ? 'er' : '');
                    default:
                    case 'M':
                    case 'Q':
                    case 'DDD':
                    case 'd':
                        return number + (number === 1 ? 'er' : 'e');
                    case 'w':
                    case 'W':
                        return number + (number === 1 ? 're' : 'e');
                }
            }
        });
        m.__ticketack_fr_ch_ordinal_patched = true;
    };
}

if (typeof globalThis.ticketack_configure_moment !== 'function') {
    globalThis.ticketack_configure_moment = function (lang) {
        if (!globalThis.moment)
            return;
        globalThis.ticketack_patch_moment_fr_ch_ordinal(globalThis.moment);
        globalThis.moment.locale(globalThis.ticketack_moment_locale(lang));
    };
}

/**
 * Display rules on the variant (like pricing.rules).
 * Missing, [], or a non-object = unrestricted.
 */
if (typeof globalThis.ticketack_variant_rules !== 'function') {
    globalThis.ticketack_normalize_variant_rules = function (value) {
        if (!value || typeof value !== 'object' || Array.isArray(value)) {
            return {};
        }
        return value;
    };
    globalThis.ticketack_variant_rules = function (variant) {
        return globalThis.ticketack_normalize_variant_rules(variant && variant.rules);
    };
}

/**
 * Display/eligibility: seller roles (mirrors ArticleVariant::can_be_sold_by).
 * Missing only_for_roles = unrestricted. Empty [] = nobody.
 */
if (typeof globalThis.ticketack_variant_matches_roles !== 'function') {
    globalThis.ticketack_variant_matches_roles = function (variant, roles) {
        var rules = globalThis.ticketack_variant_rules(variant);
        if (!Object.prototype.hasOwnProperty.call(rules, 'only_for_roles')) {
            return true;
        }
        var allowed = rules.only_for_roles;
        if (!Array.isArray(allowed)) {
            return true;
        }
        if (!Array.isArray(roles)) {
            return false;
        }
        return allowed.filter(function (role) {
            return roles.indexOf(role) !== -1;
        }).length > 0;
    };
}

if (typeof globalThis.ticketack_discount_matches_roles !== 'function') {
    globalThis.ticketack_discount_matches_roles = function (discount, roles) {
        return globalThis.ticketack_variant_matches_roles({ discount: discount }, roles);
    };
}

/**
 * Display/eligibility: cart tickettypes
 * (mirrors ArticleVariant::matches_tickettypes).
 */
if (typeof globalThis.ticketack_variant_matches_tickettypes !== 'function') {
    globalThis.ticketack_variant_matches_tickettypes = function (variant, tickettype_ids) {
        var rules = globalThis.ticketack_variant_rules(variant);
        var ids = Array.isArray(tickettype_ids) ? tickettype_ids : [];

        if (Object.prototype.hasOwnProperty.call(rules, 'only_for_tickettypes')
            && Array.isArray(rules.only_for_tickettypes)) {
            if (rules.only_for_tickettypes.filter(function (id) {
                return ids.indexOf(id) !== -1;
            }).length === 0) {
                return false;
            }
        }

        if (Object.prototype.hasOwnProperty.call(rules, 'exclude_tickettypes')
            && Array.isArray(rules.exclude_tickettypes)) {
            if (rules.exclude_tickettypes.filter(function (id) {
                return ids.indexOf(id) !== -1;
            }).length > 0) {
                return false;
            }
        }

        return true;
    };
}

if (typeof globalThis.ticketack_discount_matches_tickettypes !== 'function') {
    globalThis.ticketack_discount_matches_tickettypes = function (discount, tickettype_ids) {
        return globalThis.ticketack_variant_matches_tickettypes({ discount: discount }, tickettype_ids);
    };
}

if (typeof globalThis.ticketack_variant_matches_dates !== 'function') {
    globalThis.ticketack_variant_matches_dates = function (variant, now) {
        var rules = globalThis.ticketack_variant_rules(variant);
        var ts = now instanceof Date ? now.getTime() : Date.now();
        if (rules.not_before) {
            var start = Date.parse(rules.not_before);
            if (!isNaN(start) && ts < start) {
                return false;
            }
        }
        if (rules.not_after) {
            var stop = Date.parse(rules.not_after);
            if (!isNaN(stop) && ts > stop) {
                return false;
            }
        }
        return true;
    };
}

/**
 * Whether a POS / shop article variant should be shown given seller roles
 * and tickettypes currently in the cart. Applies to every article type.
 */
if (typeof globalThis.ticketack_variant_visible !== 'function') {
    globalThis.ticketack_variant_visible = function (variant, roles, tickettype_ids) {
        if (!variant) {
            return true;
        }
        return globalThis.ticketack_variant_matches_roles(variant, roles)
            && globalThis.ticketack_variant_matches_tickettypes(variant, tickettype_ids)
            && globalThis.ticketack_variant_matches_dates(variant);
    };
}

if (typeof globalThis.ticketack_discount_variant_visible !== 'function') {
    globalThis.ticketack_discount_variant_visible = function (variant, roles, tickettype_ids) {
        return globalThis.ticketack_variant_visible(variant, roles, tickettype_ids);
    };
}

/**
 * Mirror PricingStockHelper::cart_item_tickettype_id for POS cart JSON
 * (items have type/item_id, not tickettype_id, until activation).
 */
if (typeof globalThis.ticketack_cart_item_tickettype_id !== 'function') {
    globalThis.ticketack_cart_item_tickettype_id = function (item) {
        if (!item || item.canceled) {
            return null;
        }
        if (item.type === 'screening') {
            return 'one-time-pass';
        }
        if (item.type === 'pass' || item.type === 'badge' || item.type === 'renewal') {
            return item.item_id ? String(item.item_id) : null;
        }
        return null;
    };
}

/**
 * Unique tickettype ids from a POS cart payload ($rootScope.cart).
 * Accepts both `items` (API) and `cart_items` (internal).
 */
if (typeof globalThis.ticketack_cart_tickettype_ids !== 'function') {
    globalThis.ticketack_cart_tickettype_ids = function (cart) {
        if (!cart) {
            return [];
        }
        var items = cart.items || cart.cart_items || [];
        var seen = {};
        var ids = [];
        for (var i = 0; i < items.length; i++) {
            var id = globalThis.ticketack_cart_item_tickettype_id(items[i]);
            if (id && !seen[id]) {
                seen[id] = true;
                ids.push(id);
            }
        }
        return ids;
    };
}
